module.exports = __webpack_public_path__ + "img/open-house-flyer-icon.e088f79d.svg";